import Home from "./home";
import ExchangeMall from "./exchangeMall";
import ExchangeRecord from './exchangeRecord'
import BuyPowerRecord from "@/view/supperzzle/buyPowerRecord";
import PowerPay from "@/view/supperzzle/powerPay";
export default {
  Home,
  ExchangeMall,
  ExchangeRecord,
  BuyPowerRecord,
  PowerPay,
}